import { Brand } from '../types/brand'

export const WEBSITES: Record<Brand, Record<'nl' | 'en' | 'de', string>> = {
  boatbiketours: {
    nl: 'https://www.boatbiketours.nl/',
    de: 'https://www.boatbiketours.de/',
    en: 'https://www.boatbiketours.com/'
  },
  inselhuepfen: {
    nl: 'https://www.inselhuepfen.com/en',
    de: 'https://www.inselhuepfen.com/',
    en: 'https://www.inselhuepfen.com/en'
  },
  kootstra: {
    nl: 'https://www.kootstra.de/',
    de: 'https://www.kootstra.de/',
    en: 'https://www.kootstra.de/'
  }
}
